import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

// A PureComponent
const EventPage = React.memo(({ children }: PropsWithChildren) => {
    return (
        <ContentContainer>
            <Content>{children}</Content>
        </ContentContainer>
    )
})

export default EventPage

const ContentContainer = styled.div`
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    @media (orientation: portrait) {
        text-align: left;
    }
`

const Content = styled.div`
    max-width: 50%;

    @media (orientation: portrait) {
        max-width: 80%;
    }
`
